var map = {
	"./ContainerMountPaths.vue": 79434,
	"./Mount.vue": 61221,
	"./awsElasticBlockStore.vue": 65294,
	"./azureDisk.vue": 66126,
	"./azureFile.vue": 3837,
	"./emptyDir.vue": 94080,
	"./gcePersistentDisk.vue": 48288,
	"./hostPath.vue": 86902,
	"./index.vue": 55079,
	"./nfs.vue": 76484,
	"./secret.vue": 3890,
	"./vsphereVolume.vue": 76002,
	"edit/workload/storage/ContainerMountPaths.vue": 79434,
	"edit/workload/storage/Mount.vue": 61221,
	"edit/workload/storage/awsElasticBlockStore.vue": 65294,
	"edit/workload/storage/azureDisk.vue": 66126,
	"edit/workload/storage/azureFile.vue": 3837,
	"edit/workload/storage/emptyDir.vue": 94080,
	"edit/workload/storage/gcePersistentDisk.vue": 48288,
	"edit/workload/storage/hostPath.vue": 86902,
	"edit/workload/storage/index.vue": 55079,
	"edit/workload/storage/nfs.vue": 76484,
	"edit/workload/storage/secret.vue": 3890,
	"edit/workload/storage/vsphereVolume.vue": 76002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68219;